(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["diamants-section"]) return;
  try {
    
// On Load
const defaultRadio = document.getElementById('default-radio');
const listRadio = document.getElementById('list-radio');
  
document.addEventListener('DOMContentLoaded', function() {
  // Retrieve the display option from localStorage
  const displayOption = localStorage.getItem('displayOption');

  // Set the default radio button as checked if no value is found in localStorage
  if (!displayOption) {
    listRadio.checked = true;
  } else {
    // Set the radio button based on the stored display option
    if (displayOption === 'default') {
      defaultRadio.checked = true;
      cardContainer.style.display = 'block';
      tableContainer.style.display = 'none';
      catalogHeaderButtons.style.display = 'none';
      searchBar.style.display = 'none';
    } else if (displayOption === 'list') {
      listRadio.checked = true;
      cardContainer.style.display = 'none';
      tableContainer.style.display = 'block';
      catalogHeaderButtons.style.display = 'contents';
      searchBar.style.display = 'flex';
    }
  }
});

  
// For Modal
let imageLink = document.querySelectorAll('.image-link');
let videoLink = document.querySelectorAll('.video-link');
let certiLink = document.querySelectorAll('.certi-link');
let rapLink = document.querySelectorAll('.rap-link');
  
let iframeModal = document.querySelector('.iframe-modal');
let iframeModalCloseButton = document.querySelector('.iframe-modal-close-button');
let modalIframe = document.querySelector('.modal-iframe');

let imageModal = document.querySelector('.image-modal');
let imageModalCloseButton = document.querySelector('.image-modal-close-button');
let modalImg = document.querySelector('.modal-image');
  
function showIframeModal() {
  hideImageModal();
  iframeModal.style.display = 'block';
}

function hideIframeModal() {
  iframeModal.style.display = 'none';
}

function showImageModal(imageSrc) {
  hideIframeModal();
  modalImg.src = imageSrc;
  imageModal.style.display = 'block';
}

function hideImageModal() {
  imageModal.style.display = 'none';
}

[...imageLink].forEach(function (elem) {
  elem.addEventListener('click', function(event) {
    event.preventDefault();
    showImageModal(this.href);
  })
});

[...videoLink].forEach(function (elem) {
  elem.addEventListener('click', function() {
    iframeModal.style.width = "50vw"
    showIframeModal();
  })
});

[...certiLink].forEach(function (elem) {
  elem.addEventListener('click', function() {
    iframeModal.style.width = "80vw"
    showIframeModal();
  })
});

[...rapLink].forEach(function (elem) {
  elem.addEventListener('click', function() {
    iframeModal.style.width = "80vw";
    showIframeModal();
  })
});

iframeModalCloseButton.addEventListener('click', function() {
  hideIframeModal();
})

imageModalCloseButton.addEventListener('click', function() {
  hideImageModal();
})

// For Search Bar
let searchInput = document.querySelector('.search-bar input[type="text"]');
let tableRows = document.querySelectorAll('.product-table tbody tr');
let cards = document.querySelectorAll('.card');

searchInput.addEventListener('input', function() {
  let searchValue = this.value.trim().toLowerCase();
  
  tableRows.forEach(function(row) {
    let columns = row.querySelectorAll('td');
    let rowVisible = false;

    columns.forEach(function(column) {
      if (column.textContent.toLowerCase().indexOf(searchValue) > -1) {
        rowVisible = true;
      }
    });

    row.style.display = rowVisible ? 'table-row' : 'none';
  });

   cards.forEach(function(card) {
    let cardVisible = false;
    let cardContent = card.querySelector('.card-details');

    if (cardContent) {
      let cardText = cardContent.textContent.toLowerCase();
      if (cardText.indexOf(searchValue) > -1) {
        cardVisible = true;
      }
    }

    card.style.display = cardVisible ? 'flex' : 'none';
  });
});
  
// For Sorting
let columnHeaders = document.querySelectorAll('.product-table th');
let sortDirection = {};

columnHeaders.forEach(function (header) {
  header.addEventListener('click', function () {
    let columnIndex = Array.from(columnHeaders).indexOf(header);
    let rows = Array.from(tableRows);

    // Determine the sort direction for the column
    if (sortDirection[columnIndex] === 'ascending') {
      sortDirection[columnIndex] = 'descending';
      this.classList.remove('ascending');
      this.classList.add('descending');
    } else {
      sortDirection[columnIndex] = 'ascending';
      this.classList.remove('descending');
      this.classList.add('ascending');
    }

    // Sort the rows based on the column values
    rows.sort(function (a, b) {
      let aValue = a.querySelectorAll('td')[columnIndex].textContent.trim();
      let bValue = b.querySelectorAll('td')[columnIndex].textContent.trim();

      if (sortDirection[columnIndex] === 'ascending') {
        return aValue.localeCompare(bValue, undefined, { numeric: true });
      } else {
        return bValue.localeCompare(aValue, undefined, { numeric: true });
      }
    });

    // Reorder the rows in the table body
    let tbody = document.querySelector('.product-table tbody');
    tbody.innerHTML = '';

    rows.forEach(function (row) {
      tbody.appendChild(row);
    });
  });
});

// For Comparing Products
const compareButton = document.querySelector('.compare-button');
const compareModal = document.getElementById('compare-modal');
const compareModalCloseButton = compareModal.querySelector('.compare-modal-close');

compareButton.addEventListener('click', function() {
  const selectedRows = Array.from(document.querySelectorAll('.product-table tbody tr'))
    .filter(row => row.querySelector('input[type="checkbox"]').checked);

  if (selectedRows.length < 2) {
    // Show the modal with a custom message
    const comparisonResults = document.getElementById('comparison-results');
    comparisonResults.innerHTML = '<p>Please select at least 2 products to compare.</p>';
    compareModal.style.display = 'block';
  } else {
    // Perform comparison logic and populate comparisonResults
    const comparisonResults = document.getElementById('comparison-results');
    // Clear previous results
    comparisonResults.innerHTML = '';
    comparisonResults.appendChild(generateComparisonTable(selectedRows));
    compareModal.style.display = 'block';
  }
});

compareModalCloseButton.addEventListener('click', function() {
  compareModal.style.display = 'none';
});

window.addEventListener('click', function(event) {
  if (event.target == compareModal) {
    compareModal.style.display = 'none';
  }
});

function generateComparisonTable(selectedRows) {
  // Create the table element
  const table = document.createElement('table');
  table.classList.add('comparison-table');
  table.classList.add('outlined-table'); // Add a class for table outlines

  // Create the table body
  const tbody = document.createElement('tbody');

  // Get the product table body
  const productTableBody = document.querySelector('.product-table tbody');

  // Get the number of products being compared
  const numProducts = selectedRows.length;

  // Get the number of columns in the product table body
  const numColumns = productTableBody.rows[0].cells.length;

  // Get the column headers from the product table body
  const columnHeaders = document.querySelectorAll('.product-table thead tr:last-child th');

  // Create the comparison table rows
  for (let rowIndex = 1; rowIndex < numColumns; rowIndex++) {
    // Create a new row in the comparison table
    const comparisonRow = document.createElement('tr');

    // Create the first cell in the comparison row for the column header
    const columnHeaderCell = document.createElement('th');
    columnHeaderCell.textContent = columnHeaders[rowIndex].textContent;
    columnHeaderCell.classList.add('bold-header'); // Add a class for bold header

    // Append the cell to the comparison row
    comparisonRow.appendChild(columnHeaderCell);

    // Iterate over the checked rows and create corresponding cells in the comparison row
    selectedRows.forEach(function (row, productIndex) {
      // Get the cell from the product table body
      const cell = row.cells[rowIndex].cloneNode(true);

      cell.classList.add('centered-cell');

      // Append the cell to the comparison row
      comparisonRow.appendChild(cell);
    });

    // Append the comparison row to the table body
    tbody.appendChild(comparisonRow);
  }

  table.appendChild(tbody);

  return table;
}

// For Add to Cart
const addToCartButton = document.querySelector('.add-to-cart-button');

addToCartButton.addEventListener('click', function() {
  const rows = document.querySelectorAll('.product-table tbody tr');
  const productIds = [];
  
  rows.forEach(row => {
    const checkbox = row.querySelector('input[type="checkbox"]');
    if (checkbox.checked) {
      const productId = row.getElementsByClassName('product-id-column')[0].getElementsByTagName('a')[0].innerHTML;
      productIds.push(productId);
    }
  });

  if (productIds.length > 0) {
    // Construct the request body
    const itemsPromises = productIds.map(productId => {
      return fetch(window.Shopify.routes.root + `products/${productId}.js`)
        .then(response => response.json())
        .then(data => {
          const variantId = data.variants[0].id;
          return {
            id: variantId,
            quantity: 1
          };
        })
        .catch(error => {
          console.error(error);
        });
    });

    Promise.all(itemsPromises)
    .then(items => {
      const requestBody = {
        items: items.filter(item => item !== undefined)
      };

      // Create the fetch request
      const url = window.Shopify.routes.root + 'cart/add.js';
      const options = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(requestBody),
      };
  
      // Send the POST request
      fetch(url, options)
        .then(response => response.json())
        .then(data => {
          // Handle the response data
          showDialog('Selected items have been added to the cart.');
        })
        .catch(error => {
          // Handle any errors
          console.error(error);
          showDialog('An error occurred while adding items to the cart.');
        });
      })
    .catch(error => {
      console.error(error);
      showDialog('An error occurred while adding items to the cart.');
    });
  } else {
    showDialog('Please select at least one item to add to the cart.');
  }
});

function showDialog(message) {
  const dialog = document.getElementById('dialog');
  const dialogMessage = document.getElementById('dialog-message');
  const dialogOkButton = document.getElementById('dialog-ok-button');

  dialogMessage.textContent = message;
  dialog.style.display = 'block';

  dialogOkButton.addEventListener('click', hideDialog);
}

function hideDialog() {
  const dialog = document.getElementById('dialog');
  const dialogOkButton = document.getElementById('dialog-ok-button');

  dialog.style.display = 'none';
  dialogOkButton.removeEventListener('click', hideDialog);
}

// Get the radio buttons (already on top) and containers
const cardContainer = document.getElementById('card-container');
const tableContainer = document.getElementById('table-container');
const catalogHeader = document.querySelector('.catalog-header');
const catalogHeaderButtons = document.getElementById('catalog-header-buttons');
const searchBar = document.querySelector('.search-bar');

// Add event listeners to the radio buttons
defaultRadio.addEventListener('change', function() {
  if (this.checked) {
    cardContainer.style.display = 'block';
    tableContainer.style.display = 'none';
    catalogHeaderButtons.style.display = 'none';
    searchBar.style.display = 'none';
    // catalogHeader.classList.add('page-width');
    // searchBar.style.marginLeft = "0px";

    // Store the display option in localStorage
    localStorage.setItem('displayOption', 'default');
  }
});

listRadio.addEventListener('change', function() {
  if (this.checked) {
    cardContainer.style.display = 'none';
    tableContainer.style.display = 'block';
    catalogHeaderButtons.style.display = 'contents';
    searchBar.style.display = 'flex';
    // catalogHeader.classList.remove('page-width');
    // searchBar.style.marginLeft = "10px";

    // Store the display option in localStorage
    localStorage.setItem('displayOption', 'list');
  }
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

})();
